import React from "react";
import threeunitFJJ from "../assets/images/3unitFJJ.jpg";


const FjjDetails = () => {
  return (
    <section className="team-details">
      <div className="container">
        <div className="row justify-content-between">
          <div className="col-lg-5">
            <div className="team-details__content">
              <h2 className="team-details__title">分拣机设备</h2>
              <h3 className="team-details__subtitle" style={{ fontWeight: "bold" }}>产品特点</h3>
              <strong style={{ color: "black" }}>分拣准确率:  </strong>
              分隔式同步传送,输液品间无干扰；机械手分拣。
              多传感器检测,软硬件同时检查，确保分拣率达100%.<br />
              <strong style={{ color: "black" }}>动态分拣：</strong>
              支持科室非绑定或绑定仓位分拣，支持手动、自动出仓。<br />
              <strong style={{ color: "black" }}>信息化管控：</strong>
              实时追踪每一袋（瓶）静脉用药的全部配制信息，准确判断该药物所处状态，实时与HIS系统的药品信息进行交换及核对，保证了静脉用药从分配批次、打印标签开始到最终成品药物交付病区护士站期间各环节药品信息的准确无误；



              <h3 className="team-details__subtitle">设计理念</h3>
              <p className="team-details__text">
                结构简单、耐用、可靠。设计原理上就将故障发生的可能性降到最低。
                部件选用上遵循“大马拉小车”的原则，保证部件寿命的足够设计冗余，以满足医院这一特殊用户群体的无故障要求。
                模块化设计，独特的动态仓位分布系统。即使单一模块故障，也能完成整个分拣流程。
                所有子系统均要满足软件硬件double-check的原则，以保证系统的稳定可靠杜绝故障的发生。
              </p>


            </div>
          </div>
          <div className="col-lg-6">
            <h2 className="team-details__title" style={{ fontWeight: "bold" }}>运用场景</h2>
            <p className="team-details__text">
              运用条码实时提取技术，结合自动化流水线，将PIVAS成品输液按科室，快速高效的分拣，把人工解放出来。
            </p>
            <br />
            <div className="team-one__single">
              <div className="course-one__image">
                <img src={threeunitFJJ} alt="" />
              </div>

              <div className="team-one__content">
                <h2 className="team-one__name">
                  <a href="/team-details">直线分拣机设备</a>
                </h2>
                <p className="team-one__designation">苏州卫捷</p>
              </div>
              <div className="team-one__social">
                <a href="#none">
                  <i className="fab "></i>
                </a>

                {/* <a href="#none">
                  <i className="fab fa-twitter"></i>
                </a>
                <a href="#none">
                  <i className="fab fa-facebook-square"></i>
                </a>
                <a href="#none">
                  <i className="fab fa-pinterest-p"></i>
                </a>
                <a href="#none">
                  <i className="fab fa-instagram"></i>
                </a> */}
              </div>

            </div>

          </div>
        </div>
      </div>
    </section>
  );
};

export default FjjDetails;
